/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stop_Call_On_TimeInputs */

const fr_stop_call_on_time = /** @type {(inputs: Stop_Call_On_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À l'heure`)
};

const en_stop_call_on_time = /** @type {(inputs: Stop_Call_On_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On time`)
};

/**
* | output |
* | --- |
* | "On time" |
*
* @param {Stop_Call_On_TimeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const stop_call_on_time = /** @type {((inputs?: Stop_Call_On_TimeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stop_Call_On_TimeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_stop_call_on_time(inputs)
	return en_stop_call_on_time(inputs)
});